/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect } from "react";
import { TreeView } from "@mui/x-tree-view/TreeView";
import SimplicityTreeItem from "components/tree/website/simplicity-tree-item";
import { getParentGuids } from "components/tree/website/get-parents";
import useGetSelectedNodeId from "hooks/useGetSelectedNodeId";
import { SVGIcons } from "cms/icons/svg-icons";
// import { Logger } from "cms/utils/log/logger";

const SimplicityTreeView = (props) => {
    
    const root = props?.root;
    const selectNode = props?.selectNode;
    const selectedNodeId = useGetSelectedNodeId();
    const [expanded, setExpanded] = React.useState([]);
    const [selected, setSelected] = React.useState(selectedNodeId);

    useEffect(() => {
        setSelected(selectedNodeId);
        const parents = getParentGuids(root, selectedNodeId);
        parents.push(selectedNodeId);
        setExpanded(parents);
    }, [selectedNodeId, root]);

    const handleSelect = (event, nodeIds) => {
        setSelected(nodeIds);
        selectNode(nodeIds);
    };
    
    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };
    
    return (
        <TreeView
            aria-label='website navigator'
            defaultCollapseIcon={<SVGIcons.common.TreeCollapse />}
            defaultExpandIcon={<SVGIcons.common.TreeExpand />}
            onNodeToggle={handleToggle}
            onNodeSelect={handleSelect}
            expanded={expanded}
            // selected={selectedNodeId}
            selected={selected}
            defaultSelected={selectedNodeId}
            sx={{
                minHeightheight: "50vh",
                flexGrow: 1,
                // maxWidth: 400,
                overflowY: "auto",
            }}
        >
            {root && (
                <SimplicityTreeItem item={root}>
                    {root.children && root.children.map((child, index) => <SimplicityTreeItem key={index} item={child} />)}
                </SimplicityTreeItem>
            )}
        </TreeView>
    );
};

SimplicityTreeView.displayName = "SimplicityTreeView";
export { SimplicityTreeView };
